import { DateRange } from 'bold-ui/lib/components/Chart'
import { blue, gray } from 'bold-ui/lib/styles/colors'
import moment, { Moment } from 'moment'

export const LIMITE_INFERIOR_SEMANAS_GRAFICO_PRE_TERMO = 27
export const LIMITE_SUPERIOR_SEMANAS_GRAFICO_PRE_TERMO = 64
export const MEIO_SEMANAS_GRAFICO_PRE_TERMO = 45
export const LABEL_PRE_TERMO = 'Pré-termo'

export interface PeriodoPreTermo {
  init: Moment
  end: Moment
}

export const buildAreasPreTermo = (periodoPreTermo: PeriodoPreTermo, intervaloGrafico: DateRange) => {
  const inicioGrafico = moment(intervaloGrafico.init).startOf('day')
  const fimGrafico = moment(intervaloGrafico.end).endOf('day')

  const fimFaixaPreTermo = moment(periodoPreTermo.end).endOf('day')

  const inicioFaixaPreTermoAjustado = inicioGrafico
  const fimFaixaPreTermoAjustado = fimFaixaPreTermo.isAfter(fimGrafico) ? fimGrafico : fimFaixaPreTermo

  return [
    {
      name: 'Pré-termo',
      init: inicioFaixaPreTermoAjustado,
      end: fimFaixaPreTermoAjustado,
      fillColor: 'none',
      tickColor: blue.c60,
      strokeColor: gray.c40,
      tooltip: 'Para acompanhar o crescimento de crianças prematuras, aplique a faixa etária Pré-termo.',
      mask: {
        show: true,
        hideDots: {
          from: inicioFaixaPreTermoAjustado,
          to: fimFaixaPreTermoAjustado,
        },
        fillOpacity: 1,
        overlayDots: false,
      },
    },
  ]
}

/*
 * No gráfico de pré-termo, o eixo X não representa idade cronológica como nos demais gráficos,
 * mas sim a idade pós-menstrual, iniciando em LIMITE_INFERIOR_SEMANAS_GRAFICO_PRE_TERMO (27 semanas)
 * e terminando em LIMITE_SUPERIOR_SEMANAS_GRAFICO_PRE_TERMO (64 semanas).
 *
 * Como os cálculos das áreas de referência e TickIdade são baseados em idade cronológica
 * (diferença entre data de referência e data de nascimento),
 * precisamos deslocar artificialmente a data de nascimento.
 *
 * Para isso, criamos uma "data de nascimento virtual", subtraindo
 * LIMITE_INFERIOR_SEMANAS_GRAFICO_PRE_TERMO (27 semanas) do início do período pré-termo.
 *
 * Assim, no ponto inicial do gráfico:
 * - a idade cronológica calculada será 0 semanas
 * - mas visualmente representará 27 semanas de idade pós-menstrual
 *
 * Esse deslocamento permite reutilizar toda a lógica baseada em idade cronológica
 * sem alterar as fórmulas das curvas de referência.
 */
export const dataNascimentoPreTermo = (periodoPreTermo: PeriodoPreTermo) => {
  return periodoPreTermo.init.clone().subtract(LIMITE_INFERIOR_SEMANAS_GRAFICO_PRE_TERMO, 'weeks')
}
